import React, { useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    CircularProgress,
    Alert
} from '@mui/material';
import { useTFA } from '../context/TFAContext';
import OTPInput from './OTPInput';
import {useAuth} from "../context/AuthContext";

const TFAVerification = ({ token, onSuccess }) => {
    const { isLoading } = useTFA();
    const { verifyLoginTFA } = useAuth();
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');

    const handleVerify = async () => {
        try {
            setError('');
            const response = verifyLoginTFA(otp);
            onSuccess(response);
        } catch (err) {
            setError('Érvénytelen kód. Kérjük próbálja újra.');
        }
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Kétfaktoros hitelesítés
                </Typography>
                <Typography variant="body1" paragraph>
                    Kérjük, írja be a Google Authenticator alkalmazásból kapott 6 számjegyű kódot
                </Typography>

                <OTPInput
                    value={otp}
                    onChange={setOtp}
                    error={!!error}
                    autoFocus
                />

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Button
                    variant="contained"
                    onClick={handleVerify}
                    disabled={otp.length !== 6 || isLoading}
                    fullWidth
                >
                    {isLoading ? <CircularProgress size={24} /> : 'Ellenőrzés'}
                </Button>
            </CardContent>
        </Card>
    );
};

export default TFAVerification; 